import { connect } from 'react-redux'
import Tabs from './Tabs'

const mapStateToProps = state => ({
  stock: state.stock
})

const mapDispatchToProps = {}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Tabs)
